import { useRef } from "react";
import {
  PTForm,
  PTTextInput,
  PTTranslate,
} from "../../../common/components/ui";
import { changePasswordValidationSchema } from "../others/changePasswordValidationSchemas";
import { changePasswordInitialValues } from "../others/changePasswordInitialValues";
import { useChangePassword } from "../../../common/hooks";
import { Alert } from "@mui/material";
import { useAuth } from "../../../common/provider";

const ChangePasswordComponent = () => {
  const {
    needsPasswordChange,
    setShowChangePasswordDialog,
    setNeedsPasswordChange
  } = useAuth();
  const { mutate: changePassword, isPending } = useChangePassword();
  const formRef = useRef();

  const handleSubmit = (values) => {
    const payload = {
      oldPassword: values?.oldPassword,
      newPassword: values?.newPassword,
    };

    changePassword(payload, {
      onSuccess() {
        if (formRef.current) {
          formRef.current.resetForm();
        }
        if (needsPasswordChange) {
          localStorage.removeItem("needsPasswordChange");
          setNeedsPasswordChange(false);
          setShowChangePasswordDialog(false);
        }
      },
    });
  };

  return (
    <>
      {needsPasswordChange && (
        <Alert severity="warning" sx={{ marginBottom: 2.5 }}>
          <PTTranslate tk={"change.password.warning.text"} />
        </Alert>
      )}
      <PTForm
        name="change_password"
        initialValues={changePasswordInitialValues}
        onSubmit={handleSubmit}
        submitButtonText={needsPasswordChange ? "change.password" : "Submit"}
        validationSchema={changePasswordValidationSchema}
        retableOn={false}
        fullWidthSubmitButton={true}
        formRef={formRef}
        buttonStyle={{
          width: "100%",
          maxWidth: "100%",
          py: 1,
          border: "none",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: "primary",
          },
          "&:focus": {
            backgroundColor: "primary",
          },
        }}
        isPending={isPending}
      >
        <PTTextInput
          lg={12}
          md={12}
          hiddenLabel={true}
          name="oldPassword"
          type="password"
          placeHolder={"old.password"}
        />
        <PTTextInput
          lg={12}
          md={12}
          hiddenLabel={true}
          name="newPassword"
          type="password"
          placeHolder={"new.password"}
        />
        <PTTextInput
          lg={12}
          md={12}
          hiddenLabel={true}
          name="confirmPassword"
          type="password"
          placeHolder={"confirm.password"}
        />
      </PTForm>
    </>
  );
};

export default ChangePasswordComponent;
